import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    component: null,
    props: null,
    title:null
};

export const popupSlice = createSlice({
    name: 'popup',
    initialState,
    reducers: {
        showPopup: (state, action) => {
            let { component, props, title } = action.payload
            state.component = component || null
            state.props = props || null
            state.title = title || null
        },
        dismissPopup: (state) => {
            state.component = null;
            state.props = null;
        }
    },
})

export const { showPopup, dismissPopup } = popupSlice.actions

export default popupSlice.reducer